import type { NavItem } from '@/app/nav/collect'

/**
 * "Organization profile" is the legacy menu entry, declared once by the shell (`src/modules/shell/nav.ts`, id
 * `company-profile`) and already pointing at this module's path; `/organizations` is the navbar's gear button (WP-01).
 * The module adds no entry.
 */
const nav: NavItem[] = []

export default nav
